import { Characteristic } from "./characteristic.entity";
import { ProfessionalSpeciality } from "../enums/professional-speciality";
import { ProfessionalTitle } from "../enums/professional-title";
import { User } from "./user.entity";

export class Profile extends User {
  public professionalTitle: ProfessionalTitle = null;
  public professionalSpeciality: ProfessionalSpeciality = null;
  public haveRpps: boolean = false;
  public rpps: string = "";
  public professionalAddress = {
    street: "",
    zipCode: "",
    city: "",
  };
  public consentHcpCgu: boolean = false;
  public consentHcpMandatoryProcessing: boolean = false;
  public consentHcpOptionalFormation: boolean = false;
  public consentHcpOptionalNews: boolean = false;
  public consentHcpOptionalPanel: boolean = false;

  /**
   * Transforms received object to Profile entity
   * @param input
   * @returns Profile entity
   */
  public override deserialize(input?: any): Profile {
    super.deserialize(input);

    if (input["characteristics"]) {
      for (const [key, value] of Object.entries(this.professionalAddress)) {
        const capitalizedAddressField =
          key.charAt(0).toUpperCase() + key.slice(1);
        const addressField = "professionalAddress" + capitalizedAddressField;
        const index = input["characteristics"].findIndex(
          (item) => item.characteristicType.code == addressField
        );

        if (index > -1) {
          this.professionalAddress[key] = input["characteristics"][index].value;
          this.characteristics.push(
            new Characteristic().deserialize(input["characteristics"][index])
          );
        }
      }
    }

    return this;
  }

  /**
   * Updates a characteristic of profile
   * @param characteristic
   */
  public override updateCharacteristic(characteristic: Characteristic): void {
    super.updateCharacteristic(characteristic);

    for (const [key, value] of Object.entries(this.professionalAddress)) {
      const capitalizedAddressField =
        key.charAt(0).toUpperCase() + key.slice(1);
      const addressField = "professionalAddress" + capitalizedAddressField;

      if (characteristic.characteristicType.code.toLowerCase() != addressField.toLowerCase()) {
        continue;
      }

      this.professionalAddress[key] = characteristic.value;

      // Add/Update characteristics list
      if (characteristic.getId()) {
        const index = this.characteristics.findIndex(
          (item) => item.characteristicType.code.toLowerCase() == addressField.toLowerCase()
        );
        index > -1
          ? (this.characteristics[index] = characteristic)
          : this.characteristics.push(characteristic);
      }
    }
  }
}
